import React from 'react';

import { ExpandIcon } from './ExpandIcon';

/**
 * @typedef {Object} HeaderRowProps
 * @property {function} onExpand
 */

/** @type {React.FC<HeaderRowProps>} */
export const HeaderRow = ({ onExpand, children, ...props }) => {
  const handleExpandAll = React.useCallback(() => onExpand?.(true), [onExpand]);
  const handleCloseAll = React.useCallback(() => onExpand?.(false), [onExpand]);

  return (
    <tr {...props}>
      {React.Children.map(children, (child, index) =>
        (index === 0 ? (
          <th {...child.props}>
            <ExpandIcon expandable expanded onExpand={handleCloseAll} />
            <ExpandIcon expandable onExpand={handleExpandAll} />
          </th>
        ) : (
          child
        )))}
    </tr>
  );
};
